"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PENDING_UPDATES = void 0;
var PENDING_UPDATES = {
  BUTTON__UPLOAD_INVOICE: 'pendingUpdates-button-uploadInvoice',
  TEXT__REQUESTED_BY: 'pendingUpdates-span-requestedBy',
  TEXT__PROCESSING_STATUS: 'pendingUpdates-span-processingStatus',
  TEXT__NOTE: 'pendingUpdates-span-note',
  TEXT__CREATED_AT: 'pendingUpdates-span-createdAt'
};
exports.PENDING_UPDATES = PENDING_UPDATES;